import React, { useCallback, useMemo } from "react";
import {
  ToolBarType,
} from "../../type";
import { DocumentSettingType, DomainFieldConfig, DomainTreeNodeData, FieldType } from "@/pages/documentCompile/type";
import styles from "./index.module.less";
import { useShallow } from "zustand/react/shallow";
import useStore from "@/pages/documentCompile/store/useStore";
import { renderFieldEditor } from "./utils";
import useMethods from "../../hooks/usemethods";
import DomainValueSetting from "./components/DomainValueSetting";
import MainBar from "./components/MainBar";
import { closeDocument } from "@/pages/documentCompile/api/onlyoffice";
import DomainCard from "./components/DomainCard";

interface FieldManagerProps {
  onFieldValueChange?: (fieldId: string, value: any) => void;
  onGetSelectedText?: () => void;
  onInsertCustomXml?: () => void;
  children?: React.ReactNode;
  open: boolean;
  isUnmountedRef: React.RefObject<boolean>;
}

const FieldManager: React.FC<FieldManagerProps> = ({
  onFieldValueChange,
  onGetSelectedText,
  open,
  children,
  isUnmountedRef,
}) => {
  const { handleMessage, handleFieldDoubleClick } = useMethods();
  const { treeData, expandedKeys, fieldValues, documnetSettingType, documentSettingProjectData, selectedToolBar, showLeftSetting, domainTreeCardExpanded } = useStore(
    useShallow((s) => ({
      treeData: s.domainTreeData,
      expandedKeys: s.domainTreeDataExpandedKeys,
      fieldValues: s.fieldValues,
      documnetSettingType: s.documnetSettingType,
      documentSettingProjectData: s.documentSettingProjectData,
      selectedToolBar: s.selectedToolBar,
      showLeftSetting: s.showLeftSetting,
      domainTreeCardExpanded: s.domainTreeCardExpanded,
    }))
  );
  const setStoreState = useStore.setState;

  // 处理域值变化
  const handleFieldValueChange = (fieldId: string, value: any) => {
    onFieldValueChange?.(fieldId, value);
  };
  // 渲染树节点
  const renderTreeNode = (node: DomainTreeNodeData): any => ({
    ...node,
    children: node.children?.map(renderTreeNode),
  });

  const showMainBar = [ToolBarType.DOCUMENT_INFO, ToolBarType.FIELD_DOMAIN, ToolBarType.PACKAGE_INFO, ToolBarType.PROJECT_INFO].includes(selectedToolBar)
  const showLeft = [ToolBarType.DOCUMENT_INFO].includes(selectedToolBar) && showLeftSetting
  // console.log("selectedToolBar", selectedToolBar)
  return (
    <div className={styles.container} >
      {selectedToolBar === ToolBarType.PROJECT_FIELD_DOMAIN && (
        <DomainCard />
      )}
      {showMainBar && (
        <MainBar
          isUnmountedRef={isUnmountedRef}
          open={open}
          showLeft={showLeft}
        />
      )}
    </div>
  );
};

export default FieldManager;
